import InstallView from "./view/InstallView";
import LoginView from "./view/LoginView";
import CommonView from "./view/CommonView";
import AppsView from "./view/AppsView";
import UsersView from "./view/UsersView";
import GuidesView from "./view/GuidesView";
import PathwayView from "./view/PathwayView";
import RolesView from "./view/RolesView";
import BlacklistView from "./view/BlacklistView";
import PathwayMapView from "./view/PathwayMapView";
import RoleMapView from "./view/RoleMapView";
import TrashView from "./view/TrashView";
import AnalyticsView from "./view/AnalyticsView";
import AppUsersView from "./view/AppUsersView";
import ConfigView from "./view/ConfigView";
import LanguageView from "./view/LanguageView";
import AnalyticsUserView from "./view/AnalyticsUserView";
import AnalyticsGuideView from "./view/AnalyticsGuideView";
import ProfileView from "./view/ProfileView";
import PageAnalyticsView from "./view/PageAnalyticsView";
import RoleAnalyticsView from "./view/RoleAnalyticsView";
import VersionsView from "./view/VersionsView";
import InstanceView from "./view/InstanceView";
import SegmentWizardView from "./view/SegmentWizardView";
import SegmentView from "./view/SegmentView";
import OrganizationView from "./view/OrganizationView";
import OrganizationSingleView from "./view/OrganizationSingleView";
import TrialTermsView from "./view/TrialTermsView";
import SignupView from "./view/SignupView";
import AppTypeView from "./view/AppTypeView";
import ProductView from "./view/ProductView";
import IgnoreRuleView from "./view/IgnoreRuleView";
import JumpsView from "./view/JumpsView";
import TipStyleView from "./view/TipStyleView";
import SAPView from "./view/SAPView";
import BillingView from "./view/BillingView";
import TagView from "./view/TagView.js";
import DupesView from "./view/DupesView";

class ViewContainer {
    constructor() {
        this.views = [
            new InstallView(),
            new LoginView(),
            new CommonView(),
            new AppsView(),
            new UsersView(),
            new GuidesView(),
            new PathwayView(),
            new RolesView(),
            new BlacklistView(),
            new PathwayMapView(),
            new RoleMapView(),
            new TrashView(),
            new AnalyticsView(),
            new AppUsersView(),
            new ConfigView(),
            new LanguageView(),
            new AnalyticsUserView(),
            new AnalyticsGuideView(),
            new ProfileView(),
            new PageAnalyticsView(),
            new RoleAnalyticsView(),
            new VersionsView(),
            new InstanceView(),
            new SegmentView(),
            new SegmentWizardView(),
            new OrganizationView(),
            new OrganizationSingleView(),
            new TrialTermsView(),
            new SignupView(),
            new AppTypeView(),
            new ProductView(),
            new IgnoreRuleView(),
            new JumpsView(),
            new TipStyleView(),
            new SAPView(),
            new BillingView(),
            new TagView(),
            new DupesView()
        ];
    }

    initialize() {
        for (let i = 0; i < this.views.length; ++i) {
            this.views[i].init();
        }
    }

}

export default ViewContainer;
